import { ReactNode, useEffect, useState } from 'react';
import { getMimeType, textEllipsis } from 'src/utils';
import {
  DownloadIcon,
  FileIcon2,
  ImageIcon,
  TrashIcon,
  VideoIcon
} from 'src/components/common/common.icons';
import { Tooltip, Typography } from 'src/components/common';
import { colors } from 'src/constants';
import { TTextEllipsisResponse } from 'src/utils/textEllipsis/textEllipsis.types';
import { useAppDispatch } from 'src/store/hooks';
import { getFileUrl, removeChatFile } from 'src/store/chat/chat.slice';

import { TFileCardProps } from './fileCard.types';
import './fileCard.scss';
import { test } from 'src/assets/images';

const FileCard = ({
  fileName,
  id,
  key,
  s3Key = '',
  showDownloadButton = true,
  showDeleteButton,
  type = '',
  onRemove,
  ...rest
}: TFileCardProps) => {
  // Hooks
  const dispatch = useAppDispatch();

  // Utils
  const mimeType = getMimeType({ fileName });
  const renderFileName: TTextEllipsisResponse = textEllipsis({ charLimit: 29, text: fileName });

  const [url, setUrl] = useState<string>('')
  const icons: Record<typeof mimeType, ReactNode> = {
    'image/jpeg': <ImageIcon />,
    'image/png': <ImageIcon />,
    'image/gif': <ImageIcon />,
    'image/bmp': <ImageIcon />,
    'image/webp': <ImageIcon />,
    'video/mp4': <VideoIcon />,
    'video/x-msvideo': <VideoIcon />
  };

  const removeFile = () => {
    onRemove && onRemove()
    dispatch(removeChatFile({ id }));
  };
  const isImage = mimeType === 'image/jpeg' || mimeType === 'image/png' || mimeType === 'image/gif' || mimeType === 'image/bmp'
  const isVideo = mimeType === 'video/mp4' || mimeType === 'video/x-msvideo';
  console.log(key, 'key');

  useEffect(() => {
    if (type === 'preview' && s3Key) {
      dispatch(getFileUrl({ s3Key })).then((res) => {
        console.log(res.data, 'resData');
        if (res.status) {
          setUrl(res.data)
        }
      })
    }
  }, [s3Key])

  return (
    <div className="chat-program-file-card" {...rest}>
      {type === 'preview' && isImage && <img src={url} alt={fileName} className='chat-program-file-card__preview-image' />}
      {type === 'preview' && isVideo && <video className='chat-program-file-card__preview-image' src={url} controls>

      </video>}
      {(type !== 'preview' || (!isVideo && !isImage)) && <>
        <div className="chat-program-file-card__file">{icons[mimeType] || <FileIcon2 />}</div>
        <div className="chat-program-file-card__text">
          <Tooltip text={fileName} conditionToDisplay={renderFileName?.hasEllipsis}>
            <Typography
              as="p"
              variant="caption"
              fontWeight="semiBold"
              style={{ color: colors.neutral[1000] }}
            >
              {renderFileName?.text}
            </Typography>
          </Tooltip>
        </div>
        {showDownloadButton && (
          <div>
            <DownloadIcon />
          </div>
        )}
        {showDeleteButton && (
          <div onClick={removeFile}>
            <TrashIcon />
          </div>
        )}
      </>}
      
    </div>
  );
};

export default FileCard;
